module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAARpJREFUOE/dlK1SAzEUhc9ZSvoEKNh1DNF1dVsDDsXwBhg0AkerELwHptNnaFGo2naLa5BIXGD2MguTnZRZuj+0plFJbvLNObm5l/BGEu6PQcb+XtlcG0v/zMpia0AC/TRNn9apYxCMs3glhRnwxNjBOmASKdkxYFl2BehXtlwG8+OVklIEFGBA4O53rBFQBC8B8ehs/lshKVcQHm4KONLGXiwildsVoAPgvElS3veYnh0vP5+dzUWkbgW4d+tab5hVjLuYVc78qBW7kmsEzB9fZKJfP3pJpKb4sZuPWgp9IIAZyOuNfBuITP7qk00VvoE8KPrwhcB52D4NKF0Riet2bJc4AWba2OF3x05C9QDipk4NF5wdamMvvwA4S50Va/d7DAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/cathode_red.png
// module id = l2Jz
// module chunks = 2